const coffeeQuizForm = document.getElementById("coffee-quiz-form");
const quizSteps = document.getElementById("quiz-steps");
const quizLayout = document.querySelector(".quiz-layout");
const productDataScript = document.getElementById("coffee-quiz-products");
const introAssetsScript = document.getElementById("coffee-quiz-intro-assets");

const shopCurrency = quizLayout?.dataset.shopCurrency || "USD";

let products = {};
let introAssets = { benefitIcons: [] };

if (productDataScript?.textContent) {
  try {
    products = JSON.parse(productDataScript.textContent);
  } catch (error) {
    console.error("Coffee quiz: could not parse product data.", error);
  }
}

if (introAssetsScript?.textContent) {
  try {
    introAssets = JSON.parse(introAssetsScript.textContent);
  } catch (error) {
    console.error("Coffee quiz: could not parse intro assets.", error);
  }
}

const language = (document.documentElement.lang || "en")
  .toLowerCase()
  .startsWith("de")
  ? "de"
  : "en";

const translations = {
  en: {
    stepLabels: {
      intro: "Overview",
      recipient: "Recipient",
      office_employees: "Team size",
      office_size: "Team Plan",
      caffeine: "Caffeine",
      discovery: "Discovery",
      decaf_flavour: "Flavour",
      taste: "Taste",
      roast: "Roast",
      confirm: "Masterpiece",
      size: "Size",
      rc_size: "Size",
      delivery: "Delivery Schedule",
      plan: "Your Plan",
      summary: "Review",
    },
    progress: {
      selectionComplete: "Selection complete",
      questionOf: "Question {current} of {total}",
      review: "Review",
    },
    lookups: {
      recipient: { home: "Home", office: "Office" },
      caffeine: { regular: "Caffeinated", decaf: "Decaf" },
      discovery: {
        repeat: "Consistency",
        surprise: "Roasters Choice",
        rare: "Masterpiece",
      },
      flavour: { chocolate: "Smooth & sweet", fruity: "Fruity & intense" },
      taste: {
        richsweet: "Rich & sweet",
        smoothbalanced: "Smooth & balanced",
        sweetfruity: "Sweet & fruity",
      },
      roast: { espresso: "Espresso Roast", filter: "Filter Roast" },
      delivery: {
        payg: "Monthly",
        "6mo": "6-month commitment",
        "12mo": "12-month commitment",
      },
      plan: {
        payg: "Monthly",
        "6mo": "6-month commitment",
        "12mo": "12-month commitment",
      },
    },
    planPricing: {
      monthlyDelivery: "Monthly delivery",
      everyTwoWeeks: "Every 2 weeks",
      everyFourWeeks: "Every 4 weeks",
      fromPrice: "From {price} / month",
      savePercent: "Save {percent}%",
      billing: "Billed monthly",
    },
    summary: {
      labels: {
        recipient: "Recipient",
        caffeine: "Caffeine",
        discovery: "Discovery",
        flavour: "Flavour",
        taste: "Taste",
        roast: "Roast",
        match: "Match",
        size: "Size",
        cadence: "Cadence",
        delivery: "Delivery",
        commitment: "Commitment",
        quantity: "Quantity",
        subtotal: "Subtotal",
      },
      edit: "Edit",
      readMore: "READ MORE",
      addToCart: "Add to Cart",
      addingToCart: "Adding to cart…",
    },
    buttons: {
      continueToPlan: "Continue",
      startQuiz: "SUBSCRIBE NOW",
      back: "Back",
    },
    intro: {
      title: "COFFEE SUBSCRIPTIONS",
      helper:
        "Freshly roasted Single Origin coffees, curated each month and shipped worldwide. Starting from €13.21",
      benefits: [
        {
          title: "Exclusive Access",
          description:
            "Subscribers receive early and exclusive access to limited Single Origin releases and small-lot coffees: 86 points and above.",
        },
        {
          title: "Best Pricing",
          description:
            "Enjoy preferred pricing on every delivery — savings of up to 20% compared to one-time purchases.",
        },
        {
          title: "Freshly Roasted",
          description:
            "Our light roast lets the unique flavour of your coffee shine. Delivered fresh to order, with clean flavour in every cup.",
        },
        {
          title: "Direct Partnerships",
          description:
            "Building relationships and working directly with producers at the origin, we showcase the very best seasonal single origin flavour.",
        },
        {
          title: "Priority Fulfilment",
          description:
            "We deliver to more than 50 countries worldwide, working with our partners to ensure your coffee reaches you at its peak.",
        },
      ],
    },
    a11y: {
      decreaseQuantity: "Decrease quantity",
      increaseQuantity: "Increase quantity",
      decreaseEmployees: "Decrease employee count",
      increaseEmployees: "Increase employee count",
    },
    office: {
      recommendedTier: "Recommended tier: {tier}",
      recommendedMeta: "Recommended",
    },
    planBenefits: {
      roastersChoice: [
        "10% off first order in Germany",
        "Free shipping included in Germany.",
        "Pause or modify as you like.",
      ],
      office: [
        "Free shipping included in Germany.",
        "Pause or modify as you like.",
      ],
      masterpiece: [
        "Free Shipping from €44 in Germany",
        "Pause or modify as you like.",
      ],
    },
    masterpieceSchedule: {
      roastQuestion: "When will we roast the next batch of coffee?",
      cutoffQuestion: "Sign up deadline for the next shipment",
    },
    errors: {
      unresolved:
        "This result is not fully connected to Shopify yet. Go back and adjust the selection before trying again.",
      addToCart:
        "We could not add this subscription right now. Please try again.",
      sellingPlanUnavailable:
        "This subscription option is temporarily unavailable. Please contact customer-service@thebarn.de.",
    },
    stepMeta: {
      recipient: {
        title: "Who is the coffee for?",
        helper: "",
      },
      office_employees: {
        title: "How many people are you serving?",
        helper:
          "Our Office Coffee Subscription delivers freshly roasted specialty flavour on your schedule, making it easy to serve exceptional coffee every day.\n\nFor our Office Subscription, we designed an exclusive coffee that works on all machines: Allrounder from Brazil.\n\nFor larger teams or a custom delivery schedule, please contact customer-service@thebarn.de. We will help you curate the right subscription for your coffee needs.",
      },
      caffeine: {
        title: "Caffeinated or decaf?",
        helper: "",
      },
      discovery: {
        title: "Would you like to try different coffees?",
        helper:
          "There is no wrong answer here. We just need to know which of our subscriptions fit your routine!",
      },
      decaf_flavour: {
        title: "Which flavour calls to you?",
        helper: "",
      },
      taste: {
        title: "What taste notes do you enjoy most?",
        helper: "",
      },
      roast: {
        title: "Espresso or filter?",
        helper:
          "Monthly rotating favourites of our Roasters. Choose Espresso or Filter Roast.",
      },
      confirm: {
        title: "One Masterpiece every month.",
        helper:
          "The rarest coffees on the planet, scoring 90+ points. 150g of masterpiece-level coffee, roasted and delivered at the beginning of each month.\n\nThe retail value of each Masterpiece will always be a minimum of €40. The bean weight per bag is **150g** of coffee. In exceptional circumstances, the weight may vary.",
      },
      size: {
        titleHome: "How much per delivery?",
        titleOffice: "How much coffee should we send?",
        helperHome: "",
        helperOffice: "",
      },
      office_size: {
        title: "How much per delivery?",
        helper:
          "Based on the number of people, a recommended tier is pre-selected and can be adjusted.",
      },
      rc_size: {
        title: "How many bags of each coffee?",
        helper:
          "Our Most Popular Subscription. Receive two distinct whole bean coffees sourced from around the world each month. Explore unique single origin origins, varietals and processes.",
      },
      delivery: {
        title: "How often should we send your coffee?",
        helper:
          "Pick the rhythm that keeps you stocked without piling up extra coffee.",
      },
      plan: {
        title: "Choose your plan.",
        helperHome: "Commit longer for a bigger discount.",
        helperOffice:
          "Lock in the office subscription that fits your team best.",
      },
      summary: {
        title: "Review or edit your subscription.",
        helper: "",
      },
    },
    options: {
      recipient: {
        home: {
          title: "For me or as a gift",
          description: "Let us find your match.",
        },
        office: {
          title: "For Offices and heavy users",
          description:
            "Allrounder Coffee: perfect for automated coffee machines.",
        },
      },
      caffeine: {
        regular: {
          title: "Caffeinated",
          description: "Our regular lineup",
        },
        decaf: {
          title: "Decaf",
          description: "Specialty flavour without the caffeine",
        },
      },
      discovery: {
        repeat: {
          title: "I know what I love. Keep it on repeat.",
          description:
            "Choose your favourite flavour, same coffee, every time.",
        },
        surprise: {
          title: "Surprise me. Something new each delivery.",
          description:
            "Flavour that changes with the season. Curated by our team.",
          meta: "Most Popular",
        },
        rare: {
          title: "I want to try the rarest coffees out there.",
          description: "90+ microlots, innovative flavour.",
        },
      },
      flavour: {
        chocolate: {
          title: "Smooth & Sweet",
          description: "Milk chocolate. Caramel.",
        },
        fruity: {
          title: "Fruity & Intense",
          description: "Tropical fruit. Dark chocolate.",
        },
      },
      taste: {
        richsweet: {
          title: "Rich & Sweet",
          description: "Chocolate. Almond. Creamy.",
        },
        smoothbalanced: {
          title: "Smooth & Balanced",
          description: "Nougat. Plum. Honey.",
        },
        sweetfruity: {
          title: "Sweet & Fruity",
          description: "Peach. Chocolate. Velvety.",
        },
      },
      roast: {
        espresso: {
          title: "Espresso Roast",
          description: "For espresso, moka pot, or fully automatic machines.",
        },
        filter: {
          title: "Filter Roast",
          description: "For pourover, Aeropress, or French Press.",
        },
      },
      size: {
        "250g": {
          title: "250g",
          description:
            "Best for lighter weekly use or a single brewer at home.",
        },
        "2x250g": {
          title: "2 x 250g",
          description:
            "A balanced default if you want a little more breathing room.",
          meta: "Most Popular",
        },
        "1000g": {
          title: "1000g",
          descriptionHome: "The most economical option for heavy weekly use.",
          descriptionOffice: "A larger subscription for busier shared setups.",
        },
      },
      office_size: {
        "3kg": {
          title: "3kg",
        },
        "6kg": {
          title: "6kg",
        },
        "10kg": {
          title: "10kg",
        },
      },
      rc_size: {
        "500g": {
          title: "2 x 250g",
          tone: "a lighter rotating subscription",
          meta: "Most Popular",
        },
        "1000g": {
          title: "4 x 250g",
          tone: "a steadier monthly rhythm",
        },
        "1500g": {
          title: "6 x 250g",
          tone: "for bigger households or frequent brewing",
        },
      },
      delivery: {
        payg: {
          title: "Monthly",
        },
        "6mo": {
          title: "6-month commitment",
          meta: "+Free Logo Notebook included",
        },
        "12mo": {
          title: "12-month commitment",
          badge: "Most popular",
          meta: "+Free Logo T-Shirt included",
        },
      },
      plan: {
        payg: {
          title: "Monthly",
        },
        "6mo": {
          title: "6-month commitment",
          meta: "+Free Logo Notebook included",
        },
        "12mo": {
          title: "12-month commitment",
          badge: "Most popular",
          meta: "+Free Logo T-Shirt included",
        },
      },
    },
  },
  de: {
    stepLabels: {
      intro: "Überblick",
      recipient: "Empfänger",
      office_employees: "Teamgröße",
      office_size: "Büromenge",
      caffeine: "Koffein",
      discovery: "Entdeckung",
      decaf_flavour: "Geschmack",
      taste: "Profil",
      roast: "Röstung",
      confirm: "Masterpiece",
      size: "Menge",
      rc_size: "Menge",
      delivery: "Lieferintervall",
      plan: "Laufzeit",
      summary: "Übersicht",
    },
    progress: {
      selectionComplete: "Auswahl abgeschlossen",
      questionOf: "Frage {current} von {total}",
      review: "Übersicht",
    },
    lookups: {
      recipient: { home: "Zuhause", office: "Büro" },
      caffeine: { regular: "Mit Koffein", decaf: "Entkoffeiniert" },
      discovery: {
        repeat: "Konstanz",
        surprise: "Roasters Choice",
        rare: "Masterpiece",
      },
      flavour: { chocolate: "Sanft & süß", fruity: "Fruchtig & intensiv" },
      taste: {
        richsweet: "Kräftig & süß",
        smoothbalanced: "Sanft & ausgewogen",
        sweetfruity: "Süß & fruchtig",
      },
      roast: { espresso: "Espresso-Röstung", filter: "Filter-Röstung" },
      delivery: {
        payg: "Monatlich",
        "6mo": "6 Monate Laufzeit",
        "12mo": "12 Monate Laufzeit",
      },
      plan: {
        payg: "Monatlich",
        "6mo": "6 Monate Laufzeit",
        "12mo": "12 Monate Laufzeit",
      },
    },
    planPricing: {
      monthlyDelivery: "Monatliche Lieferung",
      everyTwoWeeks: "Alle 2 Wochen",
      everyFourWeeks: "Alle 4 Wochen",
      fromPrice: "Ab {price} / Monat",
      savePercent: "Spare {percent} %",
      billing: "Monatliche Abrechnung",
    },
    summary: {
      labels: {
        recipient: "Empfänger",
        caffeine: "Koffein",
        discovery: "Entdeckung",
        flavour: "Geschmack",
        taste: "Profil",
        roast: "Röstung",
        match: "Empfehlung",
        size: "Menge",
        cadence: "Lieferintervall",
        delivery: "Lieferung",
        commitment: "Abo-Dauer",
        quantity: "Anzahl",
        subtotal: "Zwischensumme",
      },
      edit: "Ändern",
      readMore: "MEHR ERFAHREN",
      addToCart: "In den Warenkorb",
      addingToCart: "Wird in den Warenkorb gelegt…",
    },
    buttons: {
      continueToPlan: "Weiter zum Plan",
      startQuiz: "JETZT ABONNIEREN",
      back: "Zurück",
    },
    intro: {
      eyebrow: "Abo-Vorteile",
      title: "UNSERE KAFFEE ABOS",
      helper:
        "Frisch geröstete Single-Origin-Kaffees, jeden Monat kuratiert und weltweit versendet Ab 13,21€",
      benefits: [
        {
          title: "Exklusiver Zugang",
          description:
            "Als Abonnent:in erhältst du exklusiven Vorabzugang zu limitierten Single Origin Releases und kleinen Lots ab 86 Punkten.",
        },
        {
          title: "Beste Preise",
          description:
            "Spare bei jeder Lieferung bis zu 20 % im Vergleich zum Einzelkauf.",
        },
        {
          title: "Frisch geröstet",
          description:
            "Unsere helle Röstung bringt den Charakter jedes Kaffees besonders klar zur Geltung. Frisch auf Bestellung geröstet für eine klare, ausdrucksstarke Tasse.",
        },
        {
          title: "Direkte Partnerschaften",
          description:
            "Durch unsere direkten Beziehungen zu Produzent:innen wählen wir die besten saisonalen Single Origin Kaffees aus.",
        },
        {
          title: "Priorisierter Versand",
          description:
            "Wir liefern in mehr als 50 Länder weltweit und arbeiten eng mit unseren Versandpartnern zusammen, damit dein Kaffee frisch und in bester Qualität bei dir ankommt.",
        },
      ],
    },
    a11y: {
      decreaseQuantity: "Anzahl reduzieren",
      increaseQuantity: "Anzahl erhöhen",
      decreaseEmployees: "Weniger Mitarbeitende",
      increaseEmployees: "Mehr Mitarbeitende",
    },
    office: {
      recommendedTier: "Empfohlene Option: {tier}",
      recommendedMeta: "Empfohlen",
    },
    planBenefits: {
      roastersChoice: [
        "10 % Rabatt auf die erste Bestellung in Deutschland",
        "Kostenloser Versand innerhalb Deutschlands.",
        "Pausiere oder passe dein Abo jederzeit an.",
      ],
      office: [
        "Kostenloser Versand innerhalb Deutschlands.",
        "Pausiere oder passe dein Abo jederzeit an.",
      ],
      masterpiece: [
        "Kostenloser Versand ab 44 € innerhalb Deutschlands",
        "Pausiere oder passe dein Abo jederzeit an.",
      ],
    },
    masterpieceSchedule: {
      roastQuestion: "Wann ist die nächste Röstung?",
      cutoffQuestion: "Anmeldeschluss für die nächste Lieferung",
    },
    errors: {
      unresolved:
        "Diese Auswahl ist noch nicht vollständig mit Shopify verbunden. Gehe zurück und passe die Auswahl an, bevor du es erneut versuchst.",
      addToCart:
        "Dieses Abo konnte gerade nicht in den Warenkorb gelegt werden. Bitte versuche es erneut.",
      sellingPlanUnavailable:
        "Diese Abo-Option ist vorübergehend nicht verfügbar. Bitte kontaktiere customer-service@thebarn.de.",
    },
    stepMeta: {
      recipient: {
        title: "Für wen ist der Kaffee?",
        helper: "",
      },
      office_employees: {
        title: "Wie viele Personen versorgst du?",
        helper:
          "Mit deinem Büro-Kaffee-Abonnement erhältst du frisch gerösteten Spezialitätenkaffee ganz nach deinem Zeitplan, sodass du jeden Tag ganz einfach hervorragenden Kaffee servieren kannst.\n\nFür dieses exklusive Abo haben wir einen Kaffee entwickelt, der auf allen Maschinen funktioniert: „Allrounder“ aus Brasilien. Ob Vollautomat, Espressomaschine oder Filterkaffeemaschine – „Allrounder“ bietet ein Geschmacksprofil, das Ihrem gesamten Team zusagt.\n\nFür größere Teams oder einen individuellen Lieferplan kontaktiere uns gerne unter customer-service@thebarn.de. Wir helfen dir dabei, das passende Abo für euren Kaffeebedarf zusammenzustellen.",
      },
      caffeine: {
        title: "Mit Koffein oder entkoffeiniert?",
        helper: "",
      },
      discovery: {
        title: "Probierst du gerne verschiedene Kaffees?",
        helper:
          "Es gibt keine falsche Antwort. Wir möchten nur wissen, welches Abo am besten zu deinem Alltag passt.",
      },
      decaf_flavour: {
        title: "Welche Aromen magst du am liebsten?",
        helper: "",
      },
      taste: {
        title: "Wie magst du deinen Kaffee am liebsten?",
        helper: "",
      },
      roast: {
        title: "Espresso oder Filter?",
        helper:
          "Unsere saisonale Auswahl. Wähle das Röstprofil, das zu deinem Setup passt.",
      },
      confirm: {
        title: "Ein Masterpiece. Jeden Monat.",
        helper:
          "Die exklusivsten Kaffees der Welt. Mit 90 Punkten und mehr bewertet. Anders als bei unseren anderen Abonnements verschicken wir unsere Masterpiece nur am Anfang des Monats.\n\nDer Referenz-Verkaufswert jedes Masterpiece liegt immer bei mindestens **40 €**. Das Bohnengewicht pro Tüte beträgt **150g** Kaffee. In Ausnahmefällen kann das Gewicht variieren.",
      },
      size: {
        titleHome: "Wie viel pro Lieferung?",
        titleOffice: "Wie viel Kaffee sollen wir schicken?",
        helperHome: "",
        helperOffice: "",
      },
      office_size: {
        title: "Wie viel pro Lieferung?",
        helper:
          "Wir empfehlen dir eine passende Option basierend auf der Personenzahl. Du kannst sie jederzeit anpassen.",
      },
      rc_size: {
        title: "Wie viele Beutel pro Kaffee?",
        helper:
          "Mit diesen Bundles erhältst du weiterhin eine wechselnde Auswahl, passend zu deinem gewählten Röstprofil.",
      },
      delivery: {
        title: "Wie oft möchtest du deinen Kaffee erhalten?",
        helper:
          "Wähle den Rhythmus, der am besten zu deinem Kaffeekonsum passt.",
      },
      plan: {
        title: "Wähle deinen Plan.",
        helperHome:
          "Mit einer längeren Laufzeit kannst du besser planen und profitierst in der Regel von einem besseren Preis.",
        helperOffice: "Das passende Office-Abo für euer Büro.",
      },
      summary: {
        title: "Dein Abo ansehen und anpassen.",
        helper: "",
      },
    },
    options: {
      recipient: {
        home: {
          title: "Für mich oder als Geschenk",
          description: "Finden wir das passende Abo für dich.",
        },
        office: {
          title: "Für Büros und Vieltrinker",
          description: "Allrounder Coffee: perfekt für Kaffeevollautomaten.",
        },
      },
      caffeine: {
        regular: {
          title: "Mit Koffein",
          description: "Unser Kaffeesortiment",
        },
        decaf: {
          title: "Entkoffeiniert",
          description: "Voller Geschmack, ganz ohne Koffein.",
        },
      },
      discovery: {
        repeat: {
          title: "Ich weiß, was ich mag. Am liebsten immer gleich.",
          description: "Wähle dein Lieblingsprofil und genieße es regelmäßig.",
        },
        surprise: {
          title: "Überrasche mich. Bei jeder Lieferung etwas Neues.",
          description: "Saisonale Kaffees, ausgewählt von unserem Team.",
          meta: "Am beliebtesten",
        },
        rare: {
          title: "Ich möchte eure seltensten Kaffees probieren.",
          description: "90+ Microlots, innovative Geschmacksprofile.",
        },
      },
      flavour: {
        chocolate: {
          title: "Sanft & süß",
          description: "Milchschokolade, Karamell.",
        },
        fruity: {
          title: "Fruchtig & intensiv",
          description: "Tropische Frucht, dunkle Schokolade.",
        },
      },
      taste: {
        richsweet: {
          title: "Kräftig & süß",
          description: "Schokolade. Mandel. Cremig.",
        },
        smoothbalanced: {
          title: "Sanft & ausgewogen",
          description: "Nougat. Pflaume. Honig.",
        },
        sweetfruity: {
          title: "Süß & fruchtig",
          description: "Pfirsich. Schokolade. Samtig.",
        },
      },
      roast: {
        espresso: {
          title: "Espresso",
          description: "Für Espresso, Mokkakanne oder Vollautomaten.",
        },
        filter: {
          title: "Filter",
          description: "Für Pour-Over, Aeropress oder French Press.",
        },
      },
      size: {
        "250g": {
          title: "250g",
          description:
            "Ideal für einen geringeren Wochenverbrauch oder dein Brew Setup zuhause.",
        },
        "2x250g": {
          title: "2 x 250g",
          description: "Die ausgewogene Wahl mit etwas mehr Spielraum.",
          meta: "Am beliebtesten",
        },
        "1000g": {
          title: "1000g",
          descriptionHome: "Das beste Preis-Leistungs-Verhältnis.",
          descriptionOffice:
            "Für Büros, in denen etwas mehr Kaffee getrunken wird.",
        },
      },
      office_size: {
        "3kg": {
          title: "3kg",
        },
        "6kg": {
          title: "6kg",
        },
        "10kg": {
          title: "10kg",
        },
      },
      rc_size: {
        "500g": {
          title: "2 x 250g",
          tone: "ein kleineres Abo mit wechselnden Kaffees",
          meta: "Am beliebtesten",
        },
        "1000g": {
          title: "4 x 250g",
          tone: "ein regelmäßiger monatlicher Rhythmus",
        },
        "1500g": {
          title: "6 x 250g",
          tone: "für größere Haushalte oder alle, die viel Kaffee trinken",
        },
      },
      delivery: {
        payg: {
          title: "Pro Lieferung zahlen",
        },
        "6mo": {
          title: "6 Monate Laufzeit",
          meta: "+Gratis Logo-Notizbuch inklusive",
        },
        "12mo": {
          title: "12 Monate Laufzeit",
          badge: "Am beliebtesten",
          meta: "+Gratis Logo-T-Shirt inklusive",
        },
      },
      plan: {
        payg: {
          title: "Pro Lieferung zahlen",
        },
        "6mo": {
          title: "6 Monate Laufzeit",
          meta: "+Gratis Logo-Notizbuch inklusive",
        },
        "12mo": {
          title: "12 Monate Laufzeit",
          badge: "Am beliebtesten",
          meta: "+Gratis Logo-T-Shirt inklusive",
        },
      },
    },
  },
};

const copy = translations[language];

const state = {
  started: false,
  recipient: null,
  employees: 10,
  recommendedTier: null,
  caffeine: null,
  discovery: null,
  flavour: null,
  taste: null,
  roast: null,
  confirmed: null,
  size: null,
  delivery: null,
  plan: null,
  quantity: 1,
  isAdding: false,
  errorMessage: "",
};

const MIN_QUANTITY = 1;
const MAX_QUANTITY = 20;
const MAX_OFFICE_EMPLOYEES = 12;

const FIELD_ORDER = [
  "recipient",
  "employees",
  "recommendedTier",
  "caffeine",
  "discovery",
  "flavour",
  "taste",
  "roast",
  "confirmed",
  "size",
  "delivery",
  "plan",
];

let stepIndex = 0;

const masterpiecePlanIdLookup = {
  payg: 717826523511,
  "6mo": 717826621815,
  "12mo": 717826654583,
};

const roastersChoicePlanIdLookup = {
  payg: 716534546807,
  "6mo": 717563003255,
  "12mo": 717563068791,
};

const officePlanIdLookup = {
  payg: 716534546807,
  "6mo": 717563003255,
  "12mo": 717563068791,
};

const planSavingsLookup = {
  roastersChoice: {
    payg: 6,
    "6mo": 12,
    "12mo": 20,
  },
  office: {
    payg: 10,
    "6mo": 18.5,
    "12mo": 26,
  },
  masterpiece: {
    payg: 5,
    "6mo": 10,
    "12mo": 15,
  },
};

const repeatSavingsPercent = 5;

const deliveryPlanIdLookup = {
  payg: 717830783351,
  "6mo": 718686126455,
  "12mo": 718686159223,
};

const sizeTextLookup = {
  "250g": "250g",
  "2x250g": "2 x 250g",
  "1000g": "1000g",
};

const roastersChoiceSizeTextLookup = {
  "500g": "2 x 250g",
  "1000g": "4 x 250g",
  "1500g": "6 x 250g",
};

const roastersChoiceTextLookup = {
  espresso: "Espresso",
  filter: "Filter",
};

const MOST_POPULAR_LABELS_BY_LANGUAGE = {
  en: ["Most Popular", "Most popular"],
  de: ["Am beliebtesten"],
};

const STEP_DEFAULT_SELECTIONS = {
  discovery: {
    field: "discovery",
    optionsKey: "discovery",
  },
  size: {
    field: "size",
    optionsKey: "size",
  },
  rc_size: {
    field: "size",
    optionsKey: "rc_size",
  },
  delivery: {
    field: "delivery",
    optionsKey: "delivery",
  },
  plan: {
    field: "plan",
    optionsKey: "plan",
  },
};

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function interpolate(template, replacements = {}) {
  return Object.entries(replacements).reduce(
    (result, [key, value]) =>
      result.replace(new RegExp(`\\{${key}\\}`, "g"), String(value)),
    template,
  );
}

function formatTextWithBreaks(value) {
  return escapeHtml(value)
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/\n\n+/g, "<br><br>")
    .replace(/\n/g, "<br>");
}

function getFlow() {
  if (!state.started) return ["intro"];

  if (!state.recipient) return ["recipient"];

  if (state.recipient === "office") {
    return ["recipient", "office_employees", "office_size", "plan", "summary"];
  }

  const flow = ["recipient", "caffeine"];

  if (state.caffeine === "decaf") {
    return [...flow, "decaf_flavour", "size", "delivery", "summary"];
  }

  if (state.caffeine !== "regular") return flow;

  flow.push("discovery");

  if (state.discovery === "repeat")
    return [...flow, "taste", "size", "delivery", "summary"];
  if (state.discovery === "surprise")
    return [...flow, "roast", "rc_size", "plan", "summary"];
  if (state.discovery === "rare")
    return [...flow, "confirm", "plan", "summary"];

  return flow;
}

function currentStepId() {
  const flow = getFlow();
  stepIndex = Math.min(stepIndex, flow.length - 1);
  return flow[stepIndex];
}

function clearDownstream(key) {
  const index = FIELD_ORDER.indexOf(key);

  if (index === -1) return;

  FIELD_ORDER.slice(index + 1).forEach((field) => {
    state[field] = null;
  });
}

function choose(key, value) {
  state[key] = value;
  state.errorMessage = "";
  clearDownstream(key);
  if (key === "employees") {
    state.recommendedTier = getOfficeRecommendedTier(value);
  }
  stepIndex += 1;
  render();
}

function goBack() {
  if (state.started && stepIndex === 0) {
    state.errorMessage = "";
    state.started = false;
    render();
    return;
  }

  if (stepIndex <= 0) return;

  state.errorMessage = "";
  stepIndex -= 1;
  render();
}

function goToStep(stepId) {
  const flow = getFlow();
  const targetIndex = flow.indexOf(stepId);

  if (targetIndex === -1) return;

  state.errorMessage = "";
  stepIndex = targetIndex;
  render();
}

function getSelectedProduct() {
  if (
    state.recipient === "home" &&
    state.caffeine === "regular" &&
    state.discovery === "repeat" &&
    state.taste === "richsweet"
  ) {
    return products.atlas;
  }

  if (
    state.recipient === "home" &&
    state.caffeine === "regular" &&
    state.discovery === "repeat" &&
    state.taste === "smoothbalanced"
  ) {
    return products.elemental;
  }

  if (
    state.recipient === "home" &&
    state.caffeine === "regular" &&
    state.discovery === "repeat" &&
    state.taste === "sweetfruity"
  ) {
    return products.genesis;
  }

  if (
    state.recipient === "home" &&
    state.caffeine === "regular" &&
    state.discovery === "surprise"
  ) {
    return products.roastersChoice;
  }

  if (
    state.recipient === "home" &&
    state.caffeine === "regular" &&
    state.discovery === "rare"
  ) {
    return products.masterpiece;
  }

  if (
    state.recipient === "home" &&
    state.caffeine === "decaf" &&
    state.flavour === "fruity"
  ) {
    return products.decafFunky;
  }

  if (
    state.recipient === "home" &&
    state.caffeine === "decaf" &&
    state.flavour === "chocolate"
  ) {
    return products.decafBalanced;
  }

  if (state.recipient === "office") {
    return products.office;
  }

  return null;
}

function getSizeLabel() {
  if (!state.size) return null;
  if (state.recipient === "office") return state.size;
  if (state.discovery === "surprise")
    return roastersChoiceSizeTextLookup[state.size] || state.size;
  return sizeTextLookup[state.size] || state.size;
}

function getRoastersChoiceBagsPerCoffee(optionTitle) {
  const match = String(optionTitle || "").match(/^\s*(\d+)\s*x/i);
  const totalBags = match ? Number(match[1]) : 0;
  return totalBags > 0 ? totalBags / 2 : 0;
}

function getRoastersChoiceSizeDescription(option) {
  const bagsPerCoffee = getRoastersChoiceBagsPerCoffee(option?.title);
  if (!bagsPerCoffee || !option?.tone) return option?.description || "";

  if (language === "de") {
    return `${bagsPerCoffee} ${bagsPerCoffee === 1 ? "Beutel" : "Beutel"} von jedem Kaffee · ${option.tone}`;
  }

  return `${bagsPerCoffee} ${bagsPerCoffee === 1 ? "bag" : "bags"} of each coffee · ${option.tone}`;
}

function formatMasterpieceDate(day, monthIndex) {
  const monthNames =
    language === "de"
      ? [
          "Januar",
          "Februar",
          "Maerz",
          "April",
          "Mai",
          "Juni",
          "Juli",
          "August",
          "September",
          "Oktober",
          "November",
          "Dezember",
        ]
      : [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];

  if (language === "de") {
    return `${day}. ${monthNames[monthIndex]}`;
  }

  const ordinal =
    day +
    (day > 0
      ? ["th", "st", "nd", "rd"][
          (day > 3 && day < 21) || day % 10 > 3 ? 0 : day % 10
        ]
      : "");
  return `${monthNames[monthIndex]} ${ordinal}`;
}

function getMasterpieceScheduleDates() {
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth();

  const lastDayOfCurrentMonth = new Date(currentYear, currentMonth + 1, 0);
  const cutoffDate = formatMasterpieceDate(
    lastDayOfCurrentMonth.getDate(),
    currentMonth,
  );

  const nextMonthIndex = (currentMonth + 1) % 12;
  const nextMonthYear = currentMonth === 11 ? currentYear + 1 : currentYear;
  const firstTuesday = new Date(nextMonthYear, nextMonthIndex, 1);

  while (firstTuesday.getDay() !== 2) {
    firstTuesday.setDate(firstTuesday.getDate() + 1);
  }

  const roastDate = formatMasterpieceDate(
    firstTuesday.getDate(),
    nextMonthIndex,
  );

  return {
    roastDate,
    cutoffDate,
  };
}

function getPrimaryVariantTitleSegment(variantTitle) {
  return String(variantTitle || "")
    .split("/")[0]
    .trim();
}

function normalizeVariantText(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/<[^>]*>/g, "")
    .replace(/\s+/g, "")
    .trim();
}

function getVariantTitleSegments(variantTitle) {
  return String(variantTitle || "")
    .split("/")
    .map((segment) => segment.trim())
    .filter(Boolean);
}

function variantMatchesExactSize(variant, sizeText) {
  return (
    normalizeVariantText(getPrimaryVariantTitleSegment(variant?.title)) ===
    normalizeVariantText(sizeText)
  );
}

function variantMatchesPlanKey(variant, planKey) {
  const planTitle = getVariantTitleSegments(variant?.title)
    .slice(1)
    .join(" ")
    .toLowerCase();

  if (planKey === "12mo") return /\b12\s*months?\b/.test(planTitle);
  if (planKey === "6mo") return /\b6\s*months?\b/.test(planTitle);
  if (planKey === "payg") {
    return /\b(monthly|pay per delivery|ongoing)\b/.test(planTitle);
  }
  return false;
}

function variantHasTitleSegment(variant, expectedSegment) {
  const normalizedExpectedSegment = normalizeVariantText(expectedSegment);
  return getVariantTitleSegments(variant?.title).some(
    (segment) => normalizeVariantText(segment) === normalizedExpectedSegment,
  );
}

function getOfficeRecommendedTier(employees = state.employees) {
  const count = Math.max(1, Number(employees) || 1);
  if (count <= 3) return "3kg";
  if (count <= 8) return "6kg";
  return "10kg";
}

function getMostPopularOptionKey(options = {}) {
  const expectedLabels = MOST_POPULAR_LABELS_BY_LANGUAGE[language] || [];
  return (
    Object.entries(options).find(
      ([, option]) =>
        expectedLabels.includes(String(option?.meta || "").trim()) ||
        expectedLabels.includes(String(option?.badge || "").trim()),
    )?.[0] || null
  );
}

function applyStepDefaultSelection(stepId) {
  if (stepId === "office_size") {
    state.size =
      state.size || state.recommendedTier || getOfficeRecommendedTier();
    return;
  }

  const config = STEP_DEFAULT_SELECTIONS[stepId];
  if (!config || state[config.field]) return;

  const defaultOptionKey = getMostPopularOptionKey(
    copy.options[config.optionsKey] || {},
  );
  if (defaultOptionKey) state[config.field] = defaultOptionKey;
}

function setEmployees(nextValue) {
  state.employees = Math.max(
    1,
    Math.min(MAX_OFFICE_EMPLOYEES, Number(nextValue) || 1),
  );
  state.recommendedTier = getOfficeRecommendedTier(state.employees);
  state.errorMessage = "";
  render();
}

function variantHasSellingPlan(variant, sellingPlanId) {
  if (!sellingPlanId) return true;
  if (
    Array.isArray(variant.sellingPlanAllocations) &&
    variant.sellingPlanAllocations.some(
      (allocation) => allocation.sellingPlanId === sellingPlanId,
    )
  ) {
    return true;
  }
  return (
    Array.isArray(variant.sellingPlanAllocationIds) &&
    variant.sellingPlanAllocationIds.includes(sellingPlanId)
  );
}

function isConsistencyFlow() {
  return state.discovery === "repeat" || state.caffeine === "decaf";
}

function getSelectedPlanKey() {
  if (isConsistencyFlow()) return state.delivery;
  return state.plan;
}

function getCommitmentStepId() {
  return isConsistencyFlow() ? "delivery" : "plan";
}

function getCommitmentLabel(planKey = getSelectedPlanKey()) {
  if (!planKey) return "";
  return copy.lookups.plan[planKey] || "";
}

function getSellingPlanIdForSelection(planKey = getSelectedPlanKey()) {
  if (state.discovery === "rare")
    return masterpiecePlanIdLookup[planKey] || null;
  if (state.recipient === "office") return officePlanIdLookup[planKey] || null;
  if (state.discovery === "surprise")
    return roastersChoicePlanIdLookup[planKey] || null;
  if (isConsistencyFlow()) {
    return deliveryPlanIdLookup[planKey] || null;
  }
  return null;
}

function getSelectedSellingPlanAllocation(variant, sellingPlanId) {
  if (
    !variant ||
    !sellingPlanId ||
    !Array.isArray(variant.sellingPlanAllocations)
  )
    return null;
  return (
    variant.sellingPlanAllocations.find(
      (allocation) => allocation.sellingPlanId === sellingPlanId,
    ) || null
  );
}

function resolveOrder(planKey = getSelectedPlanKey()) {
  const product = getSelectedProduct();

  if (!product) return { product: null, variant: null, sellingPlanId: null };

  let variant = null;
  const sellingPlanId = getSellingPlanIdForSelection(planKey);

  if (state.discovery === "rare") {
    variant = product.variants.find((candidate) =>
      variantHasSellingPlan(candidate, sellingPlanId),
    );
  } else if (state.recipient === "office") {
    const sizeText = state.size;
    const sizeVariants = product.variants.filter((candidate) =>
      variantMatchesExactSize(candidate, sizeText),
    );
    variant =
      sizeVariants.find((candidate) =>
        variantHasSellingPlan(candidate, sellingPlanId),
      ) ||
      sizeVariants.find((candidate) =>
        variantMatchesPlanKey(candidate, planKey),
      );
  } else if (state.discovery === "surprise") {
    const roastText = roastersChoiceTextLookup[state.roast];
    const sizeText = roastersChoiceSizeTextLookup[state.size];
    variant = product.variants.find(
      (candidate) =>
        variantHasTitleSegment(candidate, roastText) &&
        variantHasTitleSegment(candidate, sizeText) &&
        variantHasSellingPlan(candidate, sellingPlanId),
    );
  } else if (state.discovery === "repeat" || state.caffeine === "decaf") {
    const sizeText = sizeTextLookup[state.size];
    variant = product.variants.find((candidate) =>
      variantMatchesExactSize(candidate, sizeText),
    );
  }

  const sellingPlanAllocation = getSelectedSellingPlanAllocation(
    variant,
    sellingPlanId,
  );
  let unitPrice = sellingPlanAllocation?.price || variant?.price || 0;

  if (
    !sellingPlanAllocation &&
    state.discovery === "repeat" &&
    variant?.price
  ) {
    unitPrice = Math.round(
      variant.price * ((100 - repeatSavingsPercent) / 100),
    );
  }

  return {
    product,
    variant: variant || null,
    sellingPlanId,
    sellingPlanAllocation,
    sellingPlanUnavailable: Boolean(
      state.recipient === "office" &&
      variant &&
      sellingPlanId &&
      !sellingPlanAllocation,
    ),
    unitPrice,
  };
}

function getPlanCadenceLabel(order) {
  const planName = (
    order?.sellingPlanAllocation?.sellingPlanName || ""
  ).toLowerCase();

  if (planName.includes("2 week")) return copy.planPricing.everyTwoWeeks;
  if (planName.includes("4 week")) return copy.planPricing.everyFourWeeks;
  if (isConsistencyFlow()) return copy.planPricing.everyFourWeeks;

  return copy.planPricing.monthlyDelivery;
}

function getVariantSavingsPercent(variant) {
  const match = String(variant?.title || "").match(
    /\bsave\s+(\d+(?:[.,]\d+)?)\s*%/i,
  );
  if (!match) return null;

  const percent = Number(match[1].replace(",", "."));
  return Number.isFinite(percent) ? percent : null;
}

function getPlanSavingsPercent(planKey, order) {
  const variantSavingsPercent = getVariantSavingsPercent(order?.variant);
  if (variantSavingsPercent !== null) return variantSavingsPercent;
  if (isConsistencyFlow()) return repeatSavingsPercent;
  if (state.recipient === "office") {
    return planSavingsLookup.office[planKey] || 0;
  }
  if (state.discovery === "surprise") {
    return planSavingsLookup.roastersChoice[planKey] || 0;
  }
  if (state.discovery === "rare") {
    return planSavingsLookup.masterpiece[planKey] || 0;
  }
  return 0;
}

function formatSavingsPercent(percent) {
  return new Intl.NumberFormat(language, {
    maximumFractionDigits: 1,
  }).format(percent);
}

function getPlanOptionDescription(planKey) {
  const order = resolveOrder(planKey);
  if (!order.variant) return "";

  const currentPrice = order.unitPrice || order.variant.price || 0;
  const savingsPercent = getPlanSavingsPercent(planKey, order);
  return [
    interpolate(copy.planPricing.fromPrice, {
      price: formatMoney(currentPrice),
    }),
    interpolate(copy.planPricing.savePercent, {
      percent: formatSavingsPercent(savingsPercent),
    }),
  ].join(" · ");
}

function getPlanBenefits() {
  if (state.recipient === "office") return copy.planBenefits.office || [];
  if (state.discovery === "surprise")
    return copy.planBenefits.roastersChoice || [];
  if (state.discovery === "rare") return copy.planBenefits.masterpiece || [];
  return [];
}

function formatMatchTitle(value) {
  const text = String(value || "").trim();
  if (!text) return text;
  const isAllCaps = text === text.toUpperCase();
  if (!isAllCaps) return text;

  return text
    .toLowerCase()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

function getSummaryRows(order) {
  const rows = [];
  const selectedPlanKey = getSelectedPlanKey();
  const commitmentStepId = getCommitmentStepId();

  if (state.recipient)
    rows.push({
      label: copy.summary.labels.recipient,
      value: copy.lookups.recipient[state.recipient],
      stepId: "recipient",
    });
  if (state.recipient === "office" && state.employees)
    rows.push({
      label: copy.stepLabels.office_employees,
      value: String(state.employees),
      stepId: "office_employees",
    });
  if (state.caffeine)
    rows.push({
      label: copy.summary.labels.caffeine,
      value: copy.lookups.caffeine[state.caffeine],
      stepId: "caffeine",
    });
  if (state.discovery)
    rows.push({
      label: copy.summary.labels.discovery,
      value: copy.lookups.discovery[state.discovery],
      stepId: "discovery",
    });
  if (state.flavour)
    rows.push({
      label: copy.summary.labels.flavour,
      value: copy.lookups.flavour[state.flavour],
      stepId: "decaf_flavour",
    });
  if (state.taste)
    rows.push({
      label: copy.summary.labels.taste,
      value: copy.lookups.taste[state.taste],
      stepId: "taste",
    });
  if (state.roast)
    rows.push({
      label: copy.summary.labels.roast,
      value: copy.lookups.roast[state.roast],
      stepId: "roast",
    });
  if (order.product)
    rows.push({
      label: copy.summary.labels.match,
      value: formatMatchTitle(order.product.title),
      stepId: null,
      href: order.product.url || null,
      actionLabel: copy.summary.readMore,
    });
  if (getSizeLabel())
    rows.push({
      label: copy.summary.labels.size,
      value: getSizeLabel(),
      stepId:
        state.recipient === "office"
          ? "office_size"
          : state.discovery === "surprise"
            ? "rc_size"
            : "size",
    });
  if (selectedPlanKey && order.variant)
    rows.push({
      label: copy.summary.labels.delivery,
      value: getPlanCadenceLabel(order),
      stepId: commitmentStepId,
    });
  if (selectedPlanKey)
    rows.push({
      label: copy.summary.labels.commitment,
      value: getCommitmentLabel(selectedPlanKey),
      stepId: commitmentStepId,
    });

  return rows;
}

function formatMoney(cents) {
  const amount = (cents || 0) / 100;

  try {
    return new Intl.NumberFormat(document.documentElement.lang || "en", {
      style: "currency",
      currency: shopCurrency,
    }).format(amount);
  } catch (error) {
    return amount.toFixed(2);
  }
}

function getStepMeta(stepId, flow) {
  const questionSteps = flow.filter((id) => id !== "summary");
  const questionIndex = questionSteps.indexOf(stepId);
  const questionLabel =
    questionIndex >= 0
      ? interpolate(copy.progress.questionOf, {
          current: questionIndex + 1,
          total: questionSteps.length,
        })
      : copy.progress.review;
  const metaCopy = copy.stepMeta[stepId] || {};
  const title =
    metaCopy.title ||
    (stepId === "size"
      ? state.recipient === "office"
        ? metaCopy.titleOffice
        : metaCopy.titleHome
      : "");
  const helper =
    metaCopy.helper ||
    (stepId === "size"
      ? state.recipient === "office"
        ? metaCopy.helperOffice
        : metaCopy.helperHome
      : stepId === "plan"
        ? state.recipient === "office"
          ? metaCopy.helperOffice
          : metaCopy.helperHome
        : "");

  return {
    eyebrow: stepId === "summary" ? copy.progress.review : questionLabel,
    title,
    helper,
  };
}

function renderSteps(flow, stepId) {
  if (!quizSteps) return;
  if (stepId === "intro") {
    quizSteps.hidden = true;
    quizSteps.innerHTML = "";
    return;
  }

  quizSteps.hidden = false;

  const progressSteps = flow.filter((id) => id !== "summary");
  const activeIndex = progressSteps.indexOf(stepId);
  const isSummary = stepId === "summary";
  const progressCount = Math.max(progressSteps.length, 1);

  const segmentsHtml = progressSteps
    .map((id, index) => {
      let stateClass = "";

      if (index < activeIndex || isSummary) stateClass = " is-complete";
      else if (index === activeIndex) stateClass = " is-active";

      return `<span class="quiz-progress-segment${stateClass}"><span class="quiz-progress-fill"></span></span>`;
    })
    .join("");

  quizSteps.innerHTML = `
    <div class="quiz-progress-meta">
      <div class="quiz-progress-nav">
        <button type="button" class="quiz-back-btn" data-action="back" aria-label="${escapeHtml(copy.buttons.back)}">
          <span class="quiz-back-icon" aria-hidden="true">‹</span>
          <span class="quiz-back-label">${escapeHtml(copy.buttons.back)}</span>
        </button>
      </div>
      <div class="quiz-progress-label">
        <span class="quiz-step-label">${escapeHtml(copy.stepLabels[stepId] || "")}</span>
      </div>
    </div>
    <div class="quiz-progress-track" style="--quiz-progress-count: ${progressCount};">
      ${segmentsHtml}
    </div>`;
}

function renderStickyAction(contentHtml) {
  return `
    <div class="quiz-sticky-action">
      ${contentHtml}
    </div>`;
}

function renderQuestionFrame(stepId, contentHtml, flow) {
  const meta = getStepMeta(stepId, flow);

  coffeeQuizForm.innerHTML = `
    <div class="quiz-question">
      <h2 class="quiz-title">${escapeHtml(meta.title)}</h2>
      ${meta.helper ? `<p class="quiz-helper">${formatTextWithBreaks(meta.helper)}</p>` : ""}
      ${contentHtml}
    </div>`;
}

function renderOption(option) {
  return `
    <button type="button" class="quiz-option${option.selected ? " is-selected" : ""}${option.badge ? " quiz-option--with-badge" : ""}" data-action="${escapeHtml(option.action)}">
      ${option.badge ? `<span class="badge-best-seller quiz-option-badge">${escapeHtml(option.badge)}</span>` : ""}
      <span class="quiz-option-copy">
        <span class="quiz-option-title">${escapeHtml(option.title)}</span>
        ${option.description ? `<span class="quiz-option-desc">${escapeHtml(option.description)}</span>` : ""}
        ${option.meta ? `<span class="quiz-option-meta">${escapeHtml(option.meta)}</span>` : ""}
      </span>
      <span class="quiz-option-check" aria-hidden="true"></span>
    </button>`;
}

function renderOptions(options, columns = 1) {
  return `
    <div class="quiz-options${columns === 2 ? " quiz-options--two-col" : ""}">
      ${options.map(renderOption).join("")}
    </div>`;
}

function renderPlanBenefits() {
  const benefits = getPlanBenefits();
  if (!benefits.length) return "";

  return `
    <ul class="subscription-builder-cover__benefits">
      ${benefits
        .map(
          (benefit) => `
        <li class="subscription-builder-cover__benefit">${escapeHtml(benefit)}</li>
      `,
        )
        .join("")}
    </ul>`;
}

function renderIntro() {
  const benefitsHtml = copy.intro.benefits
    .map(
      (benefit, index) => `
      <li class="quiz-intro-benefit">
        <span class="quiz-intro-benefit-icon" aria-hidden="true">
          ${introAssets.benefitIcons[index] ? `<img src="${escapeHtml(introAssets.benefitIcons[index])}" alt="" loading="lazy">` : ""}
        </span>
        <div class="quiz-intro-benefit-content">
          <h4 class="quiz-intro-benefit-title">${escapeHtml(benefit.title)}</h4>
          ${benefit.description ? `<div class="quiz-intro-benefit-copy">${escapeHtml(benefit.description)}</div>` : ""}
        </div>
      </li>`,
    )
    .join("");

  coffeeQuizForm.innerHTML = `
    <div class="quiz-intro">
      <h1 class="quiz-title">${escapeHtml(copy.intro.title)}</h1>
      <p class="quiz-helper">${formatTextWithBreaks(copy.intro.helper)}</p>
      <div class="banner__buttons">
        <button type="button" class="button button--full-width" data-action="start-quiz">${escapeHtml(copy.buttons.startQuiz)}</button>
      </div>
      <ul class="quiz-intro-benefits">
        ${benefitsHtml}
      </ul>
    </div>`;
}

function renderOfficeEmployeesControl() {
  const employees = Math.max(1, state.employees || 10);
  const recommendedTier =
    state.recommendedTier || getOfficeRecommendedTier(employees);

  return `
    <div class="quiz-employee-panel">
      <div class="quiz-qty-stepper quiz-qty-stepper--employees">
        <button type="button" class="quiz-qty-button" data-action="employee-decrease" aria-label="${escapeHtml(copy.a11y.decreaseEmployees)}">&minus;</button>
        <span class="quiz-employee-value">${employees}</span>
        <button type="button" class="quiz-qty-button" data-action="employee-increase" aria-label="${escapeHtml(copy.a11y.increaseEmployees)}">+</button>
      </div>
      <p class="quiz-employee-note">${escapeHtml(interpolate(copy.office.recommendedTier, { tier: recommendedTier }))}</p>
      ${renderStickyAction(`
        <button type="button" class="button button--full-width quiz-button" data-action="office-employees-continue">${escapeHtml(copy.buttons.continueToPlan)}</button>
      `)}
    </div>`;
}

function renderSummary() {
  const order = resolveOrder();
  const rows = getSummaryRows(order);
  const unitPrice = order.unitPrice || 0;
  const subtotal = unitPrice * state.quantity;
  const summaryError = order.sellingPlanUnavailable
    ? copy.errors.sellingPlanUnavailable
    : state.errorMessage;
  const rowsHtml = rows
    .map(
      (row) => `
      <div class="quiz-summary-row">
        <div class="quiz-summary-copy">
          <span class="quiz-summary-label">${escapeHtml(row.label)}</span>
          <span class="quiz-summary-value">${escapeHtml(row.value)}</span>
        </div>
        ${
          row.href
            ? `<a href="${escapeHtml(row.href)}" class="quiz-summary-edit">${escapeHtml(row.actionLabel || copy.summary.readMore)}</a>`
            : row.stepId
              ? `<button type="button" class="quiz-summary-edit" data-edit-step="${escapeHtml(row.stepId)}">${escapeHtml(copy.summary.edit)}</button>`
              : ""
        }
      </div>`,
    )
    .join("");

  const addToCartDisabled =
    state.isAdding || !order.variant || order.sellingPlanUnavailable;

  coffeeQuizForm.innerHTML = `
    <div class="quiz-question">
      <h2 class="quiz-title">${escapeHtml(getStepMeta("summary", getFlow()).title)}</h2>
      <p class="quiz-helper">${escapeHtml(getStepMeta("summary", getFlow()).helper)}</p>
      <div class="quiz-summary-card">
        <div class="quiz-summary">
          ${rowsHtml}
          <div class="quiz-subtotal-row">
            <span class="quiz-subtotal-label">${escapeHtml(copy.summary.labels.subtotal)}</span>
            <span class="quiz-subtotal-copy">
              <span class="quiz-subtotal-value">${escapeHtml(formatMoney(subtotal))}</span>
              <span class="quiz-subtotal-note">${escapeHtml(copy.planPricing.billing)}</span>
            </span>
          </div>
        </div>
      </div>
      ${summaryError ? `<p class="quiz-inline-error">${escapeHtml(summaryError)}</p>` : ""}
      ${renderStickyAction(`
        <button type="button" data-action="addToCart" class="button button--full-width quiz-button" ${addToCartDisabled ? "disabled" : ""}>
          ${escapeHtml(state.isAdding ? copy.summary.addingToCart : copy.summary.addToCart)}
        </button>
      `)}
    </div>`;
}

function render() {
  const flow = getFlow();
  const stepId = currentStepId();
  applyStepDefaultSelection(stepId);

  if (quizLayout) {
    quizLayout.classList.toggle("is-started", stepId !== "intro");
  }

  renderSteps(flow, stepId);

  if (stepId === "intro") {
    renderIntro();
    return;
  }

  if (stepId === "recipient") {
    const recipientOptions = copy.options.recipient;
    renderQuestionFrame(
      stepId,
      renderOptions(
        [
          {
            action: "home",
            title: recipientOptions.home.title,
            description: recipientOptions.home.description,
            selected: state.recipient === "home",
          },
          {
            action: "office",
            title: recipientOptions.office.title,
            description: recipientOptions.office.description,
            selected: state.recipient === "office",
          },
        ],
        2,
      ),
      flow,
    );
    return;
  }

  if (stepId === "caffeine") {
    const caffeineOptions = copy.options.caffeine;
    renderQuestionFrame(
      stepId,
      renderOptions(
        [
          {
            action: "regular",
            title: caffeineOptions.regular.title,
            description: caffeineOptions.regular.description,
            selected: state.caffeine === "regular",
          },
          {
            action: "decaf",
            title: caffeineOptions.decaf.title,
            description: caffeineOptions.decaf.description,
            selected: state.caffeine === "decaf",
          },
        ],
        2,
      ),
      flow,
    );
    return;
  }

  if (stepId === "office_employees") {
    renderQuestionFrame(stepId, renderOfficeEmployeesControl(), flow);
    return;
  }

  if (stepId === "discovery") {
    const discoveryOptions = copy.options.discovery;
    renderQuestionFrame(
      stepId,
      renderOptions([
        {
          action: "repeat",
          title: discoveryOptions.repeat.title,
          description: discoveryOptions.repeat.description,
          selected: state.discovery === "repeat",
        },
        {
          action: "surprise",
          title: discoveryOptions.surprise.title,
          description: discoveryOptions.surprise.description,
          badge: discoveryOptions.surprise.meta,
          selected: state.discovery === "surprise",
        },
        {
          action: "rare",
          title: discoveryOptions.rare.title,
          description: discoveryOptions.rare.description,
          selected: state.discovery === "rare",
        },
      ]),
      flow,
    );
    return;
  }

  if (stepId === "decaf_flavour") {
    const flavourOptions = copy.options.flavour;
    renderQuestionFrame(
      stepId,
      renderOptions(
        [
          {
            action: "chocolate",
            title: flavourOptions.chocolate.title,
            description: flavourOptions.chocolate.description,
            selected: state.flavour === "chocolate",
          },
          {
            action: "fruity",
            title: flavourOptions.fruity.title,
            description: flavourOptions.fruity.description,
            selected: state.flavour === "fruity",
          },
        ],
        2,
      ),
      flow,
    );
    return;
  }

  if (stepId === "taste") {
    const tasteOptions = copy.options.taste;
    renderQuestionFrame(
      stepId,
      renderOptions([
        {
          action: "richsweet",
          title: tasteOptions.richsweet.title,
          description: tasteOptions.richsweet.description,
          selected: state.taste === "richsweet",
        },
        {
          action: "smoothbalanced",
          title: tasteOptions.smoothbalanced.title,
          description: tasteOptions.smoothbalanced.description,
          selected: state.taste === "smoothbalanced",
        },
        {
          action: "sweetfruity",
          title: tasteOptions.sweetfruity.title,
          description: tasteOptions.sweetfruity.description,
          selected: state.taste === "sweetfruity",
        },
      ]),
      flow,
    );
    return;
  }

  if (stepId === "roast") {
    const roastOptions = copy.options.roast;
    renderQuestionFrame(
      stepId,
      renderOptions(
        [
          {
            action: "espresso",
            title: roastOptions.espresso.title,
            description: roastOptions.espresso.description,
            selected: state.roast === "espresso",
          },
          {
            action: "filter",
            title: roastOptions.filter.title,
            description: roastOptions.filter.description,
            selected: state.roast === "filter",
          },
        ],
        2,
      ),
      flow,
    );
    return;
  }

  if (stepId === "confirm") {
    const schedule = getMasterpieceScheduleDates();
    renderQuestionFrame(
      stepId,
      `
      <div class="quiz-masterpiece-schedule">
        <div class="quiz-masterpiece-schedule-item">
          <p class="quiz-masterpiece-schedule-question">${escapeHtml(copy.masterpieceSchedule.roastQuestion)}</p>
          <p class="quiz-masterpiece-schedule-answer">${escapeHtml(schedule.roastDate)}</p>
        </div>
        <div class="quiz-masterpiece-schedule-item">
          <p class="quiz-masterpiece-schedule-question">${escapeHtml(copy.masterpieceSchedule.cutoffQuestion)}</p>
          <p class="quiz-masterpiece-schedule-answer">${escapeHtml(schedule.cutoffDate)}</p>
        </div>
      </div>
      ${renderStickyAction(`
        <button type="button" class="button button--full-width quiz-button" data-action="confirm">${escapeHtml(copy.buttons.continueToPlan)}</button>
      `)}
    `,
      flow,
    );
    return;
  }

  if (stepId === "size") {
    const sizeOptions = copy.options.size;
    renderQuestionFrame(
      stepId,
      renderOptions([
        {
          action: "250g",
          title: sizeOptions["250g"].title,
          description: sizeOptions["250g"].description,
          selected: state.size === "250g",
        },
        {
          action: "2x250g",
          title: sizeOptions["2x250g"].title,
          description: sizeOptions["2x250g"].description,
          badge: sizeOptions["2x250g"].meta,
          selected: state.size === "2x250g",
        },
        {
          action: "1000g",
          title: sizeOptions["1000g"].title,
          description:
            state.recipient === "office"
              ? sizeOptions["1000g"].descriptionOffice
              : sizeOptions["1000g"].descriptionHome,
          selected: state.size === "1000g",
        },
      ]),
      flow,
    );
    return;
  }

  if (stepId === "office_size") {
    const officeSizeOptions = copy.options.office_size;
    const recommendedTier = state.recommendedTier || getOfficeRecommendedTier();
    if (!state.size) state.size = recommendedTier;
    renderQuestionFrame(
      stepId,
      renderOptions([
        {
          action: "3kg",
          title: officeSizeOptions["3kg"].title,
          meta: recommendedTier === "3kg" ? copy.office.recommendedMeta : "",
          badge:
            recommendedTier === "3kg" ? copy.options.plan["12mo"].badge : "",
          selected: state.size === "3kg",
        },
        {
          action: "6kg",
          title: officeSizeOptions["6kg"].title,
          meta: recommendedTier === "6kg" ? copy.office.recommendedMeta : "",
          selected: state.size === "6kg",
        },
        {
          action: "10kg",
          title: officeSizeOptions["10kg"].title,
          meta: recommendedTier === "10kg" ? copy.office.recommendedMeta : "",
          selected: state.size === "10kg",
        },
      ]),
      flow,
    );
    return;
  }

  if (stepId === "rc_size") {
    const roastersChoiceSizeOptions = copy.options.rc_size;
    renderQuestionFrame(
      stepId,
      renderOptions([
        {
          action: "500g",
          title: roastersChoiceSizeOptions["500g"].title,
          description: getRoastersChoiceSizeDescription(
            roastersChoiceSizeOptions["500g"],
          ),
          badge: roastersChoiceSizeOptions["500g"].meta,
          selected: state.size === "500g",
        },
        {
          action: "1000g",
          title: roastersChoiceSizeOptions["1000g"].title,
          description: getRoastersChoiceSizeDescription(
            roastersChoiceSizeOptions["1000g"],
          ),
          selected: state.size === "1000g",
        },
        {
          action: "1500g",
          title: roastersChoiceSizeOptions["1500g"].title,
          description: getRoastersChoiceSizeDescription(
            roastersChoiceSizeOptions["1500g"],
          ),
          selected: state.size === "1500g",
        },
      ]),
      flow,
    );
    return;
  }

  if (stepId === "delivery") {
    const deliveryOptions = copy.options.delivery;
    renderQuestionFrame(
      stepId,
      renderOptions(
        [
          {
            action: "delivery-payg",
            title: deliveryOptions.payg.title,
            description: getPlanOptionDescription("payg"),
            meta: deliveryOptions.payg.meta,
            selected: state.delivery === "payg",
          },
          {
            action: "delivery-6mo",
            title: deliveryOptions["6mo"].title,
            description: getPlanOptionDescription("6mo"),
            meta: deliveryOptions["6mo"].meta,
            selected: state.delivery === "6mo",
          },
          {
            action: "delivery-12mo",
            title: deliveryOptions["12mo"].title,
            description: getPlanOptionDescription("12mo"),
            badge: deliveryOptions["12mo"].badge,
            meta: deliveryOptions["12mo"].meta,
            selected: state.delivery === "12mo",
          },
        ],
        2,
      ),
      flow,
    );
    return;
  }

  if (stepId === "plan") {
    const planOptions = copy.options.plan;
    renderQuestionFrame(
      stepId,
      `
      ${renderOptions([
        {
          action: "payg",
          title: planOptions.payg.title,
          description: getPlanOptionDescription("payg"),
          meta: planOptions.payg.meta,
          selected: state.plan === "payg",
        },
        {
          action: "6mo",
          title: planOptions["6mo"].title,
          description: getPlanOptionDescription("6mo"),
          meta: planOptions["6mo"].meta,
          selected: state.plan === "6mo",
        },
        {
          action: "12mo",
          title: planOptions["12mo"].title,
          description: getPlanOptionDescription("12mo"),
          badge: planOptions["12mo"].badge,
          meta: planOptions["12mo"].meta,
          selected: state.plan === "12mo",
        },
      ])}
      ${renderPlanBenefits()}
    `,
      flow,
    );
    return;
  }

  if (stepId === "summary") {
    renderSummary();
  }
}

coffeeQuizForm.addEventListener("click", (event) => {
  const actionTarget = event.target.closest("[data-action]");
  const editTarget = event.target.closest("[data-edit-step]");

  if (editTarget) {
    goToStep(editTarget.getAttribute("data-edit-step"));
    return;
  }

  if (!actionTarget) return;

  const action = actionTarget.getAttribute("data-action");

  if (action === "start-quiz") {
    state.started = true;
    state.errorMessage = "";
    stepIndex = 0;
    render();
  } else if (action === "home") choose("recipient", "home");
  else if (action === "office") choose("recipient", "office");
  else if (action === "regular") choose("caffeine", "regular");
  else if (action === "decaf") choose("caffeine", "decaf");
  else if (action === "repeat") choose("discovery", "repeat");
  else if (action === "surprise") choose("discovery", "surprise");
  else if (action === "rare") choose("discovery", "rare");
  else if (action === "fruity") choose("flavour", "fruity");
  else if (action === "chocolate") choose("flavour", "chocolate");
  else if (action === "richsweet") choose("taste", "richsweet");
  else if (action === "smoothbalanced") choose("taste", "smoothbalanced");
  else if (action === "sweetfruity") choose("taste", "sweetfruity");
  else if (action === "espresso") choose("roast", "espresso");
  else if (action === "filter") choose("roast", "filter");
  else if (action === "confirm") choose("confirmed", "confirm");
  else if (action === "250g") choose("size", "250g");
  else if (action === "2x250g") choose("size", "2x250g");
  else if (action === "3kg") choose("size", "3kg");
  else if (action === "6kg") choose("size", "6kg");
  else if (action === "10kg") choose("size", "10kg");
  else if (action === "500g") choose("size", "500g");
  else if (action === "1000g") choose("size", "1000g");
  else if (action === "1500g") choose("size", "1500g");
  else if (action === "delivery-payg") choose("delivery", "payg");
  else if (action === "delivery-6mo") choose("delivery", "6mo");
  else if (action === "delivery-12mo") choose("delivery", "12mo");
  else if (action === "payg") choose("plan", "payg");
  else if (action === "6mo") choose("plan", "6mo");
  else if (action === "12mo") choose("plan", "12mo");
  else if (action === "employee-decrease") {
    setEmployees((state.employees || 10) - 1);
  } else if (action === "employee-increase") {
    setEmployees((state.employees || 10) + 1);
  } else if (action === "office-employees-continue") {
    choose("employees", state.employees || 10);
  } else if (action === "qty-decrease") {
    state.quantity = Math.max(MIN_QUANTITY, state.quantity - 1);
    render();
  } else if (action === "qty-increase") {
    state.quantity = Math.min(MAX_QUANTITY, state.quantity + 1);
    render();
  } else if (action === "addToCart") {
    addToCart();
  }
});

if (quizSteps) {
  quizSteps.addEventListener("click", (event) => {
    const backTarget = event.target.closest('[data-action="back"]');
    if (!backTarget) return;
    goBack();
  });
}

async function addToCart() {
  if (state.isAdding) return;

  const order = resolveOrder();

  if (order.sellingPlanUnavailable) {
    state.errorMessage = copy.errors.sellingPlanUnavailable;
    render();
    return;
  }

  if (!order.variant) {
    state.errorMessage = copy.errors.unresolved;
    render();
    return;
  }

  const cartDrawer = document.querySelector("cart-drawer");
  const body = {
    items: [
      {
        id: order.variant.id,
        selling_plan: order.sellingPlanId,
        quantity: state.quantity,
      },
    ],
  };

  if (cartDrawer) {
    body.sections = cartDrawer
      .getSectionsToRender()
      .map((section) => section.id);
    body.sections_url = window.location.pathname;
    cartDrawer.setActiveElement(document.activeElement);
  }

  state.isAdding = true;
  state.errorMessage = "";
  render();

  try {
    const requestConfig = fetchConfig("javascript");
    const response = await fetch(`${routes.cart_add_url}`, {
      ...requestConfig,
      headers: {
        ...requestConfig.headers,
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(body),
    });

    const data = await response.json();

    if (!response.ok) {
      state.errorMessage = copy.errors.addToCart;
      console.error("Coffee quiz: /cart/add.js failed.", data);
      return;
    }

    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: "coffee-quiz",
      productVariantId: order.variant.id,
      cartData: data,
    });

    if (cartDrawer) {
      if (cartDrawer.classList.contains("is-empty")) {
        cartDrawer.classList.remove("is-empty");
      }

      if (
        data.sections?.["cart-drawer"] &&
        data.sections?.["cart-icon-bubble"]
      ) {
        cartDrawer.renderContents(data);
      } else {
        const sectionIds = cartDrawer
          .getSectionsToRender()
          .map((section) => section.id);
        const renderedSections = await fetchBundledSections(sectionIds);

        if (renderedSections) {
          cartDrawer.renderContents({
            ...data,
            sections: renderedSections,
          });
        } else {
          cartDrawer.open();
        }
      }
    } else {
      window.location.href = "/cart";
    }
  } catch (error) {
    state.errorMessage = copy.errors.addToCart;
    console.error("Coffee quiz: could not add to cart.", error);
  } finally {
    state.isAdding = false;
    render();
  }
}

async function fetchBundledSections(sectionIds) {
  if (!Array.isArray(sectionIds) || sectionIds.length === 0) return null;

  try {
    const sectionsUrl = `${window.location.pathname}${window.location.search || ""}`;
    const response = await fetch(
      `${sectionsUrl}${sectionsUrl.includes("?") ? "&" : "?"}sections=${encodeURIComponent(sectionIds.join(","))}`,
      {
        headers: {
          Accept: "application/json",
        },
      },
    );

    if (!response.ok) return null;

    const sections = await response.json();

    return sectionIds.every(
      (sectionId) => typeof sections[sectionId] === "string",
    )
      ? sections
      : null;
  } catch (error) {
    console.error("Coffee quiz: could not fetch bundled sections.", error);
    return null;
  }
}

render();
